/** What a source link in a Home chat answer opens, shown as a small mark beside it. */
export function sourceKind(href: string): "task" | "decision" | "project" | "page" {
  if (href.startsWith("/tasks/")) return "task";
  if (href.startsWith("/decisions/") || href === "/inbox") return "decision";
  if (href.startsWith("/projects/")) return "project";
  return "page";
}
